// extracted by mini-css-extract-plugin
export var chevron = "_l6-2";
export var chevronRotated = "_l6-3";
export var header = "_l6-1";
export var section = "_l6-0";